import styles from './Spinner.module.css'

const Spinner = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		data-testid="downloading-spinner"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		className={styles.spinner}
		{...props}
	>
		<circle id="hole" cx="8" cy="8" r="1"></circle>
		<circle id="disc" cx="8" cy="8" r="7"></circle>
		<circle id="center" cx="8" cy="8" r="1.25" strokeWidth="0.75"></circle>
		<path d="M5,8 C5,6.34314575 6.34314575,5 8,5">
			<animateTransform
				attributeName="transform"
				attributeType="XML"
				type="rotate"
				from="0 8 8"
				to="360 8 8"
				dur="1000ms"
				repeatCount="indefinite"
			/>
		</path>
		<path d="M3,8 C3,5.23857625 5.23857625,3 8,3">
			<animateTransform
				attributeName="transform"
				attributeType="XML"
				type="rotate"
				from="0 8 8"
				to="360 8 8"
				dur="1000ms"
				repeatCount="indefinite"
			/>
		</path>
	</svg>
)

export default Spinner
